import { Fragment, useState } from 'react';
import { Row, Col, Button, Tooltip, Radio, Empty, Form, Input, Spin } from 'antd';
import * as _ from 'lodash';
import { useTranslation } from 'react-i18next';

const { format } = require('rut.js')

const PatientTable = ({
  loading,
  patients,
  loadMore,
  fetchAdmissionPatientPrestation,
  prestations,
  deletePatient,
  deletePatientExams,
  changeReservationNumber,
  countryCode,
  }) => {
  const { t } = useTranslation();
  const [openDeleteTooltipId, setOpenDeleteTooltipId] = useState(null);

  return (
    <Col lg={24}>
      {
        patients?.data?.length > 0 ?
          <Row justify="center" className="patient-table">
            <Col lg={22} xs={22} className="patient-wrapper mt-lg-50 mt-md-20 mt-sm-20 mt-xs-20 mb-lg-30 mb-md-20 mb-sm-20 mb-xs-20">
              <Row justify="start" className="table-header">
                <Col lg={3}>
                  <p className="mb-5 ml-15">
                    {t('admissionPatientPage.patientTable.reservationNumber')}
                  </p>
                </Col>
                <Col lg={4}>
                  <p className="text-center mb-5">
                    {t('admissionPatientPage.patientTable.patientName')}
                  </p>
                </Col>
                <Col lg={3}>
                  <p className="text-center mb-5">
                    {t('admissionPatientPage.patientTable.documentTitle')}
                  </p>
                </Col>
                <Col lg={5}>
                  <p className="text-center mb-5">Compañía</p>
                </Col>
                <Col lg={3}>
                  <p className="text-center mb-5">
                    {t('admissionPatientPage.patientTable.services')}
                  </p>
                </Col>
                <Col lg={3}>
                  <p className="text-center mb-5">Fecha de ingreso</p>
                </Col>
                <Col lg={3}>
                  <p className="text-center mb-5">Eliminar ingreso</p>
                </Col>
              </Row>
              {
                patients.data.map((patient, index) => {
                  return (
                    <Row className="table-body mb-lg-10 mb-md-15 mb-sm-15 mb-xs-15" key={index}>
                      <Col lg={3} xs={12} className="table-body__item first">
                        <Tooltip
                          trigger="click"
                          overlayClassName='edit-reservation-number-tooltip'
                          color="#FFFFFF"
                          title={
                            <Row justify="space-between">
                              <Col lg={24} className="button-wrapper">
                                <Form
                                  id={"form" + index}
                                  layout={"inline"}
                                  onFinish={(values) => changeReservationNumber(patient, values)}
                                >
                                  <Form.Item
                                    name="reservation_number"
                                    initialValue={patient.number}
                                  >
                                    <Input className="cmt-input reservation_input" />
                                  </Form.Item>
                                  <Form.Item className="clean-margin">
                                    <Button
                                      className={`icon-button`}
                                      form={"form" + index}
                                      htmlType="submit"
                                    >
                                      <i className="icon-system-edit" />
                                    </Button>
                                  </Form.Item>
                                </Form>
                              </Col>
                            </Row>
                          }>
                          <p className="mobile-title text-center">
                            {t('admissionPatientPage.patientTable.reservationNumber')}
                          </p>
                          <p className="mb-0 ml-lg-15 ml-xs-0">
                            {patient.number}
                          </p>
                        </Tooltip>
                      </Col>
                      <Col lg={4} xs={12} className="table-body__item">
                        <p className="mobile-title text-center">
                          {t('admissionPatientPage.patientTable.patientName')}
                        </p>
                        <p className="text-center mb-0">{patient.patient_full_name}</p>
                      </Col>
                      <Col lg={3} xs={12} className="table-body__item">
                        <p className="mobile-title text-center">
                          {t('admissionPatientPage.patientTable.documentTitle')}
                        </p>
                        <p className="text-center mb-0">
                          {
                            patient.documnet_type && patient.documnet_type.toLowerCase() === 'rut' ?
                              format(patient.document_number) : patient.document_number
                          }
                        </p>
                      </Col>
                      <Col lg={5} xs={12} className="table-body__item">
                        <p className="mobile-title text-center">Compañía</p>
                        <p className="text-center mb-0">{patient.business_name}</p>
                      </Col>
                      <Col lg={3} xs={12} className="table-body__item">
                        <Tooltip
                          trigger="click"
                          overlayClassName='patient-services-tooltip'
                          onClick={() => fetchAdmissionPatientPrestation({ 'admission_patient_id': patient.admission_patient_id })}
                          color="#FFFFFF"
                          title={
                            <Fragment>
                              {
                                prestations && prestations.length > 0 ?
                                  <Fragment>
                                    <Row justify="space-between">
                                      <Col lg={18}>
                                        <p className='title mb-10'>
                                          {t('admissionPatientPage.patientTable.service')}
                                        </p>
                                      </Col>
                                      <Col lg={6}>
                                        <p className="title text-center mb-10">Eliminar</p>
                                      </Col>
                                    </Row>
                                    <Fragment>
                                      {
                                        loading.detail ?
                                          <div style={{ textAlign: 'center' }}>
                                            <Spin className="custom-spinner" />
                                          </div>
                                          :
                                          prestations.map((prestation, prestationIndex) => {
                                            return (
                                              <Row justify="space-between" key={prestationIndex}>
                                                <Col lg={18}>
                                                  <p>{prestation.type_name}</p>
                                                </Col>
                                                <Col lg={6} className="button-wrapper">
                                                  <Button
                                                    className={`delete-icon-button`}
                                                    onClick={() => deletePatientExams(prestation)}
                                                  >
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.61 189.36"><g id="Capa_2" dataname="Capa 2"><g id="Capa_1-2" dataname="Capa 1"><path d="M47.16,21.25c0-3.94-.14-7.24,0-10.53C47.49,4.64,51.6.29,57.66.17q16.5-.33,33,0c6.37.11,10.48,4.42,10.78,10.79.15,3.28,0,6.58,0,10.4,11.53,0,22.48-.06,33.43,0,7.49,0,12.84,3.93,13.53,10a92.45,92.45,0,0,1,.07,10.16H.13c0-3.65-.34-7.14.08-10.54.69-5.58,5.89-9.6,12.18-9.65C23.71,21.19,35,21.25,47.16,21.25Zm46.89-.2c0-3.38,0-6.19,0-9C94,9,92.36,7.48,89.32,7.48c-10,0-20-.16-29.93.17-1.52,0-3.93,2.14-4.25,3.64-.67,3.1-.2,6.43-.2,9.76Z" /><path d="M15.42,54.5v4.63q0,58.15,0,116.31c0,10.25,4.24,13.91,16.09,13.91q42.55,0,85.09,0c12.36,0,16.25-3.36,16.25-14.11q0-57.93,0-115.88V54.5Z" /></g></g></svg>
                                                  </Button>
                                                </Col>
                                              </Row>
                                            )
                                          })
                                      }
                                    </Fragment>
                                  </Fragment>
                                  :
                                  <Empty
                                    description={
                                      <span style={{ fontSize: 12 }}>
                                        {t('admissionPatientPage.patientTable.emptyDisclaimer')}
                                      </span>
                                    }
                                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                                  />
                              }

                            </Fragment>
                          }>
                          <p className="mobile-title text-center">
                            {t('admissionPatientPage.patientTable.services')}
                          </p>
                          <p className="text-center mb-0" style={{ cursor: "pointer" }}>
                            Ver {t('admissionPatientPage.patientTable.services').toLocaleLowerCase()}
                          </p>
                        </Tooltip>
                      </Col>
                      <Col lg={3} xs={12} className="table-body__item">
                        <p className="mobile-title text-center">Fecha de ingreso</p>
                        <p className="text-center mb-0">{patient.admission_date}</p>
                      </Col>
                      <Col lg={3} xs={24} className="table-body__item button-wrapper">
                        <p className="mobile-title text-center">Eliminar ingreso</p>
                        <Tooltip
                          trigger="click"
                          color='#FFFFFF'
                          overlayClassName='delete-admission-tooltip'
                          autoAdjustOverflow
                          open={openDeleteTooltipId === patient.admission_patient_id}
                          onOpenChange={(open) => setOpenDeleteTooltipId(open ? patient.admission_patient_id : null)}
                          title={
                            <Row justify='center' gutter={[0, 10]}>
                              <Col lg={24} xs={24}>
                                <p className='text-center mb-0'>¿Estás seguro que deseas eliminar?</p>
                              </Col>
                              <Col lg={24} xs={24}>
                                <Row justify='center' gutter={10}>
                                  <Col>
                                    <Button
                                      className='cmt-button secondary outline'
                                      size='small'
                                      onClick={() => setOpenDeleteTooltipId(null)}
                                    >
                                      Cancelar
                                    </Button>
                                  </Col>
                                  <Col>
                                    <Button
                                      className='cmt-button primary'
                                      type='primary'
                                      size='small'
                                      onClick={() => {
                                        deletePatient(patient);
                                        setOpenDeleteTooltipId(null);
                                      }}
                                    >
                                      Confirmar
                                    </Button>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          }
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 148.61 189.36"><g id="Capa_2" dataname="Capa 2"><g id="Capa_1-2" dataname="Capa 1"><path d="M47.16,21.25c0-3.94-.14-7.24,0-10.53C47.49,4.64,51.6.29,57.66.17q16.5-.33,33,0c6.37.11,10.48,4.42,10.78,10.79.15,3.28,0,6.58,0,10.4,11.53,0,22.48-.06,33.43,0,7.49,0,12.84,3.93,13.53,10a92.45,92.45,0,0,1,.07,10.16H.13c0-3.65-.34-7.14.08-10.54.69-5.58,5.89-9.6,12.18-9.65C23.71,21.19,35,21.25,47.16,21.25Zm46.89-.2c0-3.38,0-6.19,0-9C94,9,92.36,7.48,89.32,7.48c-10,0-20-.16-29.93.17-1.52,0-3.93,2.14-4.25,3.64-.67,3.1-.2,6.43-.2,9.76Z" /><path d="M15.42,54.5v4.63q0,58.15,0,116.31c0,10.25,4.24,13.91,16.09,13.91q42.55,0,85.09,0c12.36,0,16.25-3.36,16.25-14.11q0-57.93,0-115.88V54.5Z" /></g></g></svg>
                        </Tooltip>
                      </Col>
                    </Row>
                  )
                })
              }
            </Col>
            <Col lg={22}>
              <Row className="mb-50">
                <Col>
                  <Radio.Group className="cmt-pagination">
                    <Radio.Button
                      value="prev"
                      disabled={patients.pagination.currentPage <= 1}
                      onClick={loadMore}
                    >
                      Anterior
                    </Radio.Button>
                    <Radio.Button
                      value="next"
                      disabled={patients.pagination === null || patients.pagination.total < patients.pagination.perPage}
                      onClick={loadMore}
                    >
                      Siguiente
                    </Radio.Button>
                  </Radio.Group>
                </Col>
                <Col className="ml-20" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <p className="mb-0">{patients.pagination.from + 1} - {patients.pagination.to} de {patients.pagination.total}</p>
                </Col>
              </Row>
            </Col>
          </Row>
          : <Empty description={<span style={{ fontSize: 12 }}>No hay ingresos</span>} image={Empty.PRESENTED_IMAGE_SIMPLE} />
      }
    </Col>
  );
};

export default PatientTable;